const undergrad = {
   title: "B.S. Computer Science, magna cum laude",
   school: "University at Buffalo, SUNY",
   location: "Buffalo, New York",
   web: "http://engineering.buffalo.edu/",
   date: "August 2016 - May 2020",
   details: [
      "Contributed as a UX/UI researcher and front-end developer to OneDataShare.",
      "2019-2020 Head Graphic Artist for the Student Association",
      "2019-2020 President & 2017-2018 Performance Cultural Chair of the Filipino American Student Association.",
   ],
};

const hs = {
   title: "Intensive Academic Humanities, Advanced Honors Regents",
   school: "Townsend Harris High School",
   location: "Queens, New York",
   web: "https://www.thhs.qc.edu/",
   date: "September 2012 - May 2016",
   details: [
      "Member of the ARISTA Honor Society",
      "Member of the ARCHON Honor Society",
      "Pit crew for the FRC2601: Steel Hawks.",
      "Member of the varsity wrestling, varsity badminton, and varsity bowling teams.",
   ],
};

export const EDUCATION = [undergrad, hs];
